const PCW_TYPE_STEP_ID = 'portfolio-type-selection';
const PCW_PORTFOLIO_BASICS_STEP_ID = 'portfolio-basics';
const PCW_ADD_BATTERY_STEP_ID = 'add-battery';
const PCW_ADD_RENEWABLES_STEP_ID = 'add-renewables';
const PCW_ADD_GENERATION_ASSET_STEP_ID = 'add-generation-asset';
const PCW_ANCILLARIES_STEP_ID = 'add-ancillaries';
const PCW_FORWARD_CURVES_STEP_ID = 'add-forward-curves';
const PCW_FORWARD_CURVES_CONSTRAINTS_STEP_ID = 'add-forward-curves-constraints';
const PCW_GLOBAL_SHAPES_STEP_ID = 'add-global-shapes';
const PCW_HEDGES_CONTRACTS_STEP_ID = 'add-hedges-contracts';
const PCW_HYDRO_STEP_ID = 'add-hydro';
const PCW_LOAD_STEP_ID = 'add-load';
const PCW_SUMMARY_STEP_ID = 'summary-step';

export const PCW_STEPS = {
    PCW_TYPE_STEP_ID,
    PCW_PORTFOLIO_BASICS_STEP_ID,
    PCW_ADD_BATTERY_STEP_ID,
    PCW_ADD_RENEWABLES_STEP_ID,
    PCW_ADD_GENERATION_ASSET_STEP_ID,
    PCW_ANCILLARIES_STEP_ID,
    PCW_FORWARD_CURVES_STEP_ID,
    PCW_FORWARD_CURVES_CONSTRAINTS_STEP_ID,
    PCW_GLOBAL_SHAPES_STEP_ID,
    PCW_HEDGES_CONTRACTS_STEP_ID,
    PCW_HYDRO_STEP_ID,
    PCW_LOAD_STEP_ID,
    PCW_SUMMARY_STEP_ID,
} as const;

export const pcwSteps = [
    PCW_STEPS.PCW_TYPE_STEP_ID,
    PCW_STEPS.PCW_PORTFOLIO_BASICS_STEP_ID,
    PCW_STEPS.PCW_FORWARD_CURVES_STEP_ID,
    PCW_STEPS.PCW_FORWARD_CURVES_CONSTRAINTS_STEP_ID,
    PCW_STEPS.PCW_GLOBAL_SHAPES_STEP_ID,
    PCW_STEPS.PCW_LOAD_STEP_ID,
    PCW_STEPS.PCW_ADD_BATTERY_STEP_ID,
    PCW_STEPS.PCW_ADD_RENEWABLES_STEP_ID,
    PCW_STEPS.PCW_ADD_GENERATION_ASSET_STEP_ID,
    PCW_STEPS.PCW_HYDRO_STEP_ID,
    PCW_STEPS.PCW_ANCILLARIES_STEP_ID,
    PCW_STEPS.PCW_HEDGES_CONTRACTS_STEP_ID,
    PCW_STEPS.PCW_SUMMARY_STEP_ID,
] as const;

export const stepsWithSelectedItems = [
    PCW_STEPS.PCW_FORWARD_CURVES_STEP_ID,
    PCW_STEPS.PCW_FORWARD_CURVES_CONSTRAINTS_STEP_ID,
    PCW_STEPS.PCW_GLOBAL_SHAPES_STEP_ID,
    PCW_STEPS.PCW_ADD_BATTERY_STEP_ID,
    PCW_STEPS.PCW_ADD_RENEWABLES_STEP_ID,
    PCW_STEPS.PCW_ADD_GENERATION_ASSET_STEP_ID,
    PCW_STEPS.PCW_HYDRO_STEP_ID,
    PCW_STEPS.PCW_ANCILLARIES_STEP_ID,
    PCW_STEPS.PCW_LOAD_STEP_ID,
    PCW_STEPS.PCW_HEDGES_CONTRACTS_STEP_ID,
] as const;
